import { render, staticRenderFns } from "./Warning.vue?vue&type=template&id=5cb8b1ac&scoped=true"
import script from "./Warning.vue?vue&type=script&lang=js"
export * from "./Warning.vue?vue&type=script&lang=js"
import style0 from "./Warning.vue?vue&type=style&index=0&id=5cb8b1ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb8b1ac",
  null
  
)

export default component.exports